import { Helmet } from "react-helmet-async";

const SITE_NAME = "Kooulu";
const SITE_URL = "https://kooulu.com";

const DEFAULT_DESCRIPTION =
  "";

const resolveCanonical = (canonical) => {
  if (canonical) {
    return canonical.startsWith("http") ? canonical : `${SITE_URL}${canonical}`;
  }
  if (typeof window !== "undefined") {
    return `${SITE_URL}${window.location.pathname}${window.location.search}`;
  }
  return SITE_URL;
};

const PageMeta = ({ title, description, keywords, canonical, robots }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = resolveCanonical(canonical);
  const robotsContent = robots || "index, follow";

  return (
    <Helmet>
      <title>{fullTitle}</title>

      <meta name="description" content={metaDescription} />
      <meta name="robots" content={robotsContent} />
      <link rel="canonical" href={canonicalUrl} />

      {keywords && (
        <meta name="keywords" content={keywords} />
      )}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
    </Helmet>
  );
};

export default PageMeta;
